import SharingDialog from './SharingDialog';

export default SharingDialog;
